import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  columns: [
    {
      label: 'Author Name', field: 'author_name'
    },
    {
      label: 'Create at', field: 'created_at'
    },
    {
      label: 'Tittle', field: 'title'
    },
    {
      label: 'Subtitle', field: 'sub_title'
    },
    {
      label: 'Category', field: 'artc_ctgr_name'
    },
    {
      label: 'Sub Category', field: 'artc_sub_ctgr_name'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: [],
  items: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/articles/status/AC'}
    useIPA.get(param).then(response => {
      const article = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...article})
    })
  },
  getPrivilege ({ commit }) {
    let param = {status: 'account/privilege'}
    useIPA.get(param).then(response => {
      const privilege = {
        rows : response.data.data.privilege_category
      }
      commit('setPrivileges', {...privilege})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'account/profile'}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const param = { rawData: {
        name: formData.name,
        phone: formData.phone,
        email: formData.email
      }, url: 'internal/account/update', id: null}
      useIPA.postputnoid(param)
			.then(response => {
        router.push({ name: 'profile' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  formPostPutPassword ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        old_password: formData.text_1,
        new_password: formData.text_2
			}
      const param = { rawData: rawData, url: 'internal/account/changepassword', id: null }
      useIPA.patchpassword(param)
			.then(response => {
        router.push({ name: 'profile' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/article', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, article) {
    state.all = article.rows
    state.pages = article.pages
  },
  setPrivileges (state, privilege) {
    const items = privilege.rows.flatMap(item => [
      ...item.privilege_category,
      ...item.privilege_category.flatMap(subItem => subItem.privilege_category || [])
    ]);
    state.items = items
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
